"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JUSTICE_ADVOCATES = exports.XSTATE_QUESTIONNAIRE = exports.COMMUNITY = exports.CASE_INCOME_STREAMS = exports.CASE_DATA_MODELS = void 0;
exports.CASE_DATA_MODELS = "caseDataModels";
exports.CASE_INCOME_STREAMS = "caseIncomeStreams";
exports.COMMUNITY = "community";
exports.XSTATE_QUESTIONNAIRE = "xstateQuestionnaire";
exports.JUSTICE_ADVOCATES = "justiceAdvocates";